import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { useColumns } from '../../components/WrapColumns/useColumns'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const ColumnsButtons = observer(() => {
  const view = useEditorView()
  const { _onSelectCol, columnCount } = useColumns({ view })

  return (
    <>
      <SingleMenuDropdownItem
        icon={<ToolbarIcon name={IconName.ColumnVertical1} />}
        label="Single Column"
        active={columnCount === 1}
        handleClick={_onSelectCol(1)}
      />
      <SingleMenuDropdownItem
        icon={<ToolbarIcon name={IconName.ColumnVertical2} />}
        label="2 Columns"
        active={columnCount === 2}
        handleClick={_onSelectCol(2)}
      />
      <SingleMenuDropdownItem
        icon={<ToolbarIcon name={IconName.ColumnVertical3} />}
        label="3 Columns"
        active={columnCount === 3}
        handleClick={_onSelectCol(3)}
      />
    </>
  )
})
